module.exports = __webpack_public_path__ + "static/media/header-logo.3def5e7e.png";